
module.exports = {
	status: 'ready',
	title: 'Accordion',
	notes: '',
	context: {
		items: [
			{title:'FMV Kommunikation (Avsänder)', update:'2019-03-06', info: {
				title: 'Ansvarig för område',
				phone: '000000000',
				mail1: 'Förnamn.efternamn@FMV.se',
				createDate: '2011-06-14',
				pageOwner: 'Förnamn Efternamn',
				mail2: 'Förnamn.efternamn@FMV.se',
			}},
		]
	},
};
